'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _largeButton = require('../large-button');

var _largeButton2 = _interopRequireDefault(_largeButton);

var _pdfLinks = require('./pdf-links.scss');

var _pdfLinks2 = _interopRequireDefault(_pdfLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Shows links for PDF
 *
 * A4 and A3 are possible
 */
var PDFLinks = function (_React$Component) {
    _inherits(PDFLinks, _React$Component);

    function PDFLinks(props) {
        _classCallCheck(this, PDFLinks);

        return _possibleConstructorReturn(this, (PDFLinks.__proto__ || Object.getPrototypeOf(PDFLinks)).call(this, props));
    }

    _createClass(PDFLinks, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'ul',
                    { className: _pdfLinks2.default.list },
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_largeButton2.default, {
                            isLink: true,
                            text: this.props.labels.a4,
                            href: '/pdf/A4',
                            target: '_blank' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_largeButton2.default, {
                            isLink: true,
                            text: this.props.labels.a3,
                            href: '/pdf/A3',
                            target: '_blank' })
                    )
                )
            );
        }
    }]);

    return PDFLinks;
}(_react2.default.Component);

PDFLinks.propTypes = {
    labels: _propTypes2.default.object.isRequired
};

exports.default = PDFLinks;


//////////////////
// WEBPACK FOOTER
// ./client/components/pdf-links/index.js
// module id = 498
// module chunks = 0